import { useMemo } from "react";
import { useSelector } from "react-redux";

import {
  isSystemField,
  resolveVisitorFields,
} from "@/lib/visitorAdditionalFields";

/**
 * Ganze Feldliste eines Standorts: Name, E-Mail, Firma und die Zusatzfelder, in
 * der eingestellten Reihenfolge (Einstellungen → Besucher → Felder im Web).
 *
 * Quelle sind die Visitor-Modul-Settings des Standorts
 * (`company.data.visitor_module_settings`, geladen über
 * `GET_VISITOR_MODULE_SETTINGS_REQUEST`); ist dort nichts gespeichert, gelten
 * die kundenweiten Altfelder aus `module_add_in_fields` und für Name, E-Mail und
 * Firma die Vorgaben.
 */
export function useVisitorFields(locationId) {
  const settingsByLocation = useSelector(
    (state) => state.company.data.visitor_module_settings,
  );
  const legacyFields = useSelector((state) => state.company.data.module_add_in_fields);

  return useMemo(
    () =>
      resolveVisitorFields(
        locationId != null ? settingsByLocation?.[String(locationId)] : null,
        legacyFields,
      ),
    [locationId, settingsByLocation, legacyFields],
  );
}

/**
 * Nur die Zusatzfelder (Telefon, Parkplatznummer, …), ohne Name, E-Mail und
 * Firma — deren Werte stehen in den Spalten des Besuchers, nie in
 * `additional_information`.
 */
export function useVisitorAdditionalFields(locationId) {
  const fields = useVisitorFields(locationId);
  return useMemo(() => fields.filter((f) => !isSystemField(f)), [fields]);
}
